import { twJoin } from 'tailwind-merge';

import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import IconCard from 'organisms/Cards/IconCard';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';

import { hasArrayValues } from 'utils/array/arrays';

import type { IconCardDeckConfig } from 'components/CardDeck/Icon/config';
import type { FC } from 'react';

const IconCardDeck: FC<IconCardDeckConfig> = props => {
  const {
    sectionProps,
    rest: { cards, ...headingProps },
  } = splitSectionProps(props);

  return (
    <Section {...sectionProps}>
      <div className="flex flex-col items-center gap-10 sm:gap-14">
        <Heading {...headingProps} alignment="leftInline" sidePadding="none" />
        <ScrollFadeSection delay={0.2}>
          <div className="-mx-4 flex flex-wrap justify-center gap-y-8">
            {hasArrayValues(cards) &&
              cards.map(card => (
                <div
                  key={card.id}
                  className={twJoin(
                    'w-full shrink-0 grow-0 px-4 sm:w-1/2 sm:basis-1/2',
                    cards.length % 3 === 0 ? 'lg:w-1/3 lg:basis-1/3' : 'lg:w-1/4 lg:basis-1/4',
                  )}
                >
                  <IconCard {...card} darkCard={sectionProps.darkMode} />
                </div>
              ))}
          </div>
        </ScrollFadeSection>
      </div>
    </Section>
  );
};

export default IconCardDeck;
